import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0780634d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-list__item" }
const _hoisted_2 = { class: "notification-list__container" }
const _hoisted_3 = { class: "notification-list__description" }
const _hoisted_4 = { class: "notification-list__item-subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass([
          'notification-list__item-title',
          { disable: _ctx.notification.isRead },
          { flag: !_ctx.notification.isRead }
        ])
      }, _toDisplayString(_ctx.notification.title), 3),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.notification.description), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formatDateTime(_ctx.notification.created_at)), 1)
    ]),
    _createElementVNode("button", {
      class: "notification-list__delete",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('delete', _ctx.notification.id)), ["stop"]))
    })
  ]))
}